module.exports = __webpack_public_path__ + "img/Button_Autospin.47d65450.png";